import type { Integration } from '../types';

export const omniconvert: Integration = {
  slug: 'omniconvert',
  icon: 'omniconvert',
  name: 'integrations:omniconvert.title',
  provider: 'integrations:omniconvert.provider',
  tokenName: null,
  actionLabel: {
    enable: 'integrations:omniconvert.enable',
  },
  description: 'integrations:omniconvert.description',
  descriptionLarge: null,
  resources: [
    {
      copy: 'integrations:omniconvert.resources.using-with-hotjar',
      url: '/articles/115009347267-Using-Hotjar-with-Omniconvert',
      icon: 'page_full',
    },
    {
      copy: 'integrations:omniconvert.resources.integrate-with-hotjar',
      url: 'https://www.omniconvert.com/help/kba/how-to-connect-hotjar-with-omniconvert/',
      icon: 'page_full',
    },
    {
      copy: 'integrations:omniconvert.resources.grow',
      url: 'https://www.omniconvert.com/blog/how-to-grow-your-website-with-hotjar-omniconvert/',
      icon: 'page_full',
    },
  ],
  images: null,
  videoUrl: null,
  gate: 'core.integrations',
  isEnabled: false,
  settings: null,
  installUrl: '/articles/115009347267-Using-Hotjar-with-Omniconvert',
};
